import { useEffect, useState } from 'react';

// Helper function to shuffle array and get random items
const getRandomTestimonials = (array, count) => {
  const shuffled = [...array].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    fetch('/testimonials.json')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load testimonials data');
        }
        return res.json();
      })
      .then((data) => {
        if (isMounted) {
          // Handle both array format and object with testimonials property
          const allTestimonials = Array.isArray(data)
            ? data
            : data.testimonials || [];
          
          // Select 3 random testimonials
          const randomTestimonials = getRandomTestimonials(allTestimonials, 3);
          setTestimonials(randomTestimonials);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(err.message || 'Something went wrong');
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-inner">
        <div className="testimonials-header">
          <h2>
            What Our <span className="accent">Clients Say</span>
          </h2>
          <p>Real stories from people who transformed their fitness journey</p>
        </div>

        {loading && <p style={{ textAlign: 'center' }}>Loading testimonials...</p>}
        {error && !loading && (
          <p style={{ textAlign: 'center', color: '#b91c1c' }}>{error}</p>
        )}

        {!loading && !error && testimonials.length > 0 && (
          <div className="testimonials-grid">
            {testimonials.map((testimonial, idx) => (
              <article key={`${testimonial.client_name || 'anonymous'}-${idx}`} className="testimonial-card">
                <div className="testimonial-content">
                  <p className="testimonial-text">&ldquo;{testimonial.testimonial}&rdquo;</p>
                </div>
                {testimonial.client_name && (
                  <div className="testimonial-author">
                    <span className="testimonial-name">{testimonial.client_name}</span>
                  </div>
                )}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default TestimonialsSection;

